
let numero = 0;
let numeroContraste = 0;

function acrescenta() {
    numero = numero + 1;
    return numero;
}
function acrescentaContraste() {
    numeroContraste = numeroContraste + 1;
    return numeroContraste;
}


export const clientes = [
    // {
    //     Logo: '../../../../../assets/img/clientes/santander.png',
    //     Empresa: 'Banco Santander',
    //     Classe: 'card-'+ acrescenta()
    // }, 
    {
        Logo: '../../../../../assets/img/clientes/bid.png',
        Empresa: 'BID',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/governosp.png',
        Empresa: 'Governo de São Paulo',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/staff.png',
        Empresa: 'STAFF',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/citibank.png',
        Empresa: 'Citibank',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/mmd2.png',
        Empresa: 'MMD2',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/cavc.png',
        Empresa: 'CAVC Idiomas',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/alfa.png',
        Empresa: 'Banco Alfa',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/fastshop.png',
        Empresa: 'Fast Shop',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/daycoval.png',
        Empresa: 'Banco Daycoval',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/luz.png',
        Empresa: 'Albatross',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/confidence.png',
        Empresa: 'Confidence Câmbio',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/cv.png',
        Empresa: 'Code V',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/sulamerica.png',
        Empresa: 'Luz Soluções Financeiras',
        Classe: 'card-' + acrescenta()
    },
    // {
    //     Logo: '../../../../../assets/img/clientes/santanderS3.png',
    //     Empresa: 'Santander Securities Services',
    //     Classe: 'card-'+ acrescenta()
    // }, 
    {
        Logo: '../../../../../assets/img/clientes/honeywell.png',
        Empresa: 'Honeywell',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/supera.png',
        Empresa: 'Supera',
        Classe: 'card-' + acrescenta()
    }, {
        Logo: '../../../../../assets/img/clientes/albatross.png',
        Empresa: 'Albatross',
        Classe: 'card-' + acrescenta()
    },

]
export const clientesContraste = [
    // {
    //     Logo: '../../../../../assets/img/clientes/santander-contraste.png',
    //     Empresa: 'Banco Santander',
    //     Classe: 'card-' + acrescentaContraste()
    // }, 
    {
        Logo: '../../../../../assets/img/clientes/bid-contraste.png',
        Empresa: 'BID',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/governosp-contraste.png',
        Empresa: 'Governo de São Paulo',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/staff-contraste.png',
        Empresa: 'STAFF',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/citibank-contraste.png',
        Empresa: 'Citibank',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/mmd2-contraste.png',
        Empresa: 'MMD2',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/cavc-contraste.png',
        Empresa: 'CAVC Idiomas',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/alfa-contraste.png',
        Empresa: 'Banco Alfa',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/fastshop-contraste.png',
        Empresa: 'Fast Shop',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/daycoval-contraste.png',
        Empresa: 'Banco Daycoval',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/luz-contraste.png',
        Empresa: 'Albatross',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/confidence-contraste.png',
        Empresa: 'Confidence Câmbio',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/cv-contraste.png',
        Empresa: 'Code V',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/sulamerica-contraste.png',
        Empresa: 'Luz Soluções Financeiras',
        Classe: 'card-' + acrescentaContraste()
    },
    // {
    //     Logo: '../../../../../assets/img/clientes/santanderS3-contraste.png',
    //     Empresa: 'Santander Securities Services',
    //     Classe: 'card-' + acrescentaContraste()
    // },
    {
        Logo: '../../../../../assets/img/clientes/honeywell-contraste.png',
        Empresa: 'Honeywell',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/supera-contraste.png',
        Empresa: 'Supera',
        Classe: 'card-' + acrescentaContraste()
    }, {
        Logo: '../../../../../assets/img/clientes/albatross-contraste.png',
        Empresa: 'Albatross',
        Classe: 'card-' + acrescentaContraste()
    },

]